import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';
import MaterialTable, { MTableBody } from 'material-table';
import { TABLE_ICONS } from '../../../../@jumbo/constants/TableIcons';
import apiService from 'services/apiService';
import LocalStorageService from 'services/LocalStorageService';
import { TableCell, TableFooter, TableRow } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import twLocale from 'date-fns/locale/zh-TW';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Box, Dialog } from '@material-ui/core';
import { Formik, Field } from 'formik';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles(theme => ({
  section: {
    '&:not(:last-child)': {
      marginBottom: theme.typography.pxToRem(32),
    },
  },
  sectionHeading: {
    marginBottom: theme.typography.pxToRem(16),
  },
}));

const breadcrumbs = [
  // { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  // { label: <IntlMessages id={'pages.editTable'} />, isActive: true },
];

export default function Table() {
  const classes = useStyles();
  const [data, setData] = React.useState({
    orderFrom: new Date(),
    orderTo: new Date(),
  });
  const [state, setState] = React.useState({
    parentsColumns: [
      { title: 'No.', render: rowData => rowData.tableData.id + 1, width: "4%" },
      { title: '訂單編號', field: 'paymentId', width: "10%" },
      { title: '會員代碼', field: 'memberCode', width: "12%" },
      { title: '購買日期', field: 'orderTime', type: 'datetime', width: "10%" },
      {
        title: '訂單來源',
        field: 'paymentType',
        render: rowData => (rowData.paymentType === 'CART' ? '購物車' : '自訂付款'),
        width: "10%"
      },
      {
        title: '付款狀態',
        field: 'paymentStatus',
        render: rowData => (rowData.paymentStatus === 'SUCCESS' ? '已付款' : '尚未付款'),
        width: "10%"
      },
      { title: '收件人', field: 'receiverName', width: "10%" },
      { title: '收件人電話', field: 'receiverPhone', width: "10%" },
      { title: '收件人地址', field: 'receiverAddress', width: "10%" },
      {
        title: '總金額',
        field: 'orderAmount',
        type: 'currency',
        cellStyle: { textAlign: 'center' },
        headerStyle: { textAlign: 'center' },
        width: "10%"
      },
    ],
    childColumns: [
      { title: '', field: '', width: "10%" },
      { title: 'No.', render: rowData => rowData.tableData.id + 1, width: "5%" },
      { title: '商品代碼', field: 'oiProdCode', width: "15%" },
      { title: '商品名稱', field: 'oiProdName', width: "25%" },
      { title: '商品購買數量', field: 'oiProdSaleQty', type: 'numeric', width: "15%" },
      { title: '商品單價', field: 'oiProdSalePrice', type: 'currency', width: "15%" },
      { title: '商品總額', type: 'currency', render: rowData => '$' + rowData.oiProdSalePrice * rowData.oiProdSaleQty, width: "15%" },
    ],
  });
  const [orderList, setOrderList] = React.useState([]);
  const [filteredOrderList, setFilteredOrderList] = React.useState([]);
  React.useEffect(() => {
    getOrderData();
  }, []);
  const getOrderData = () => {
    const storeCode = LocalStorageService.getStoreCode();
    const token = LocalStorageService.getToken();
    apiService.Order.list(storeCode).then(response => {
      apiService.log.add(
        storeCode,
        {
          requestUrl: `/order/history/list/${storeCode}`,
          requestMethod: 'POST',
          responseStatus: response.status,
        },
        token,
      );
      if (response.status === 200) {
        console.log('response', response.data.orderList);
        setOrderList(response.data.orderList);
      } else {
        console.log('orderList', 'order/list response:' + JSON.stringify(response.data));
      }
    });
  };
  // 篩選過濾
  const handleFilterOnSubmit = async values => {
    // console.log('values', values)
    // 過濾時間
    let orderFilteredByTime = orderList.filter(order => {
      const orderTimestamp = Date.parse(order.orderTime);
      return (
        orderTimestamp >= new Date(values.orderFrom).setHours(0, 0, 0, 0) &&
        orderTimestamp <= new Date(values.orderTo).setHours(23, 59, 59, 999)
      );
    });
    // console.log('orderFilteredByTime',orderFilteredByTime)
    if (orderFilteredByTime.length === 0) alert('未發現符合條件會員，請重新搜尋');
    setFilteredOrderList(orderFilteredByTime);
  };

  return (
    <PageContainer heading={<IntlMessages id="pages.order.list" />} breadcrumbs={breadcrumbs}>
      <Box
        className={classes.section}
        sx={{
          backgroundColor: '#FFF',
          padding: '10px',
          boxShadow: '0px 0px 15px rgb(0 0 0 / 20%)',
          borderRadius: '5px',
          width: '100%',
        }}>
        <Formik initialValues={data} onSubmit={handleFilterOnSubmit}>
          {props => {
            const { values, dirty, setFieldValue, isSubmitting, handleChange, handleSubmit, handleReset } = props;
            return (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={6} alignItems="center">
                  <Grid item xs={1}>
                    <Typography variant="h4" align="center">
                      篩選
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={twLocale}>
                      <DatePicker
                        margin="dense"
                        id="orderFrom"
                        name="orderFrom"
                        label="開始時間"
                        value={values.orderFrom}
                        fullWidth
                        onChange={val => {
                          // console.log('picked activity start time', val.format());
                          setFieldValue('orderFrom', val);
                        }}
                        renderInput={params => <TextField {...params} />}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={twLocale}>
                      <DatePicker
                        margin="dense"
                        id="orderTo"
                        name="orderTo"
                        label="結束時間"
                        value={values.orderTo}
                        fullWidth
                        onChange={val => {
                          // console.log('picked activity start time', val.format());
                          setFieldValue('orderTo', val);
                        }}
                        renderInput={params => <TextField {...params} />}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={1}>
                    <Button type="submit" color="primary" fullWidth="true" size="large" disabled={isSubmitting}>
                    搜尋
                    </Button>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                    type="button"
                    className="outline"
                    color="primary"
                    fullWidth="true"
                    onClick={() => {
                      handleReset();
                      // setFilteredMember([]);
                    }}
                    disabled={!dirty || isSubmitting}>
                    清除
                    </Button>
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </Box>
      <MaterialTable
        className={classes.root}
        icons={TABLE_ICONS}
        title="訂單記錄列表"
        columns={state.parentsColumns}
        data={filteredOrderList.length > 0 ? filteredOrderList : orderList}
        options={{
          actionsColumnIndex: -1,
          paging: true,
          pageSize: 10, // make initial page size
          emptyRowsWhenPaging: false, // To avoid of having empty rows
          pageSizeOptions: [10, 15, 30, 50], // rows selection options
          tableLayout: "fixed", // fixed column width
        }}
        detailPanel={rowData => {
          return (
            <MaterialTable
              icons={TABLE_ICONS}
              title="購物清單"
              columns={state.childColumns}
              data={rowData.orderItemList}
              options={{
                headerStyle: {
                  textAlign: 'center',
                  backgroundColor: 'royalblue',
                  color: 'white',
                },
                cellStyle: {
                  textAlign: 'center',
                },
              }}
              style={{
                backgroundColor: 'aliceblue',
              }}
            />
          );
        }}
        components={{
          Body: props => {
            let totalObj = {
              actualSum: 0,
            };
            props.renderData.forEach(rowData => {
              totalObj.actualSum += parseInt(rowData.orderAmount);
            });
            return (
              <>
                <MTableBody {...props} />
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={3} />
                    <TableCell colSpan={3} />
                    <TableCell
                      colSpan={5}
                      align="right"
                      style={{
                        fontSize: '1rem',
                      }}>
                      總計金額: ${totalObj.actualSum}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </>
            );
          },
        }}
      />
    </PageContainer>
  );
}
